export class Barcode {
  type: string = 'datamatrix'

  barcode: string = ''

  get displayName() {
    return `[${this.type}] ${this.barcode}`
  }
}
